import { api } from 'utils/apis/api';
/** RTKQ APIs to work with templates. */
export const templatesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        renderTemplate: builder.query({
            query: (body) => ({
                version: 1,
                path: 'templating/renderings',
                method: 'POST',
                body,
            }),
        }),
        readTemplateById: builder.query({
            query: ({ id }) => ({
                version: 2,
                path: `templating/templates/${id}`,
            }),
        }),
    }),
});
